import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import { environment } from 'src/envs/environnement';
export interface User {
    id: string;
    nom: string;
    prenom: string;
    email: string;
    role: string;
    password: string;
    idEntreprise: string;
}

export enum RoleUtilisateur {
    ADMINISTRATEUR="ADMINISTRATEUR",
    SUPERADMINISTRATEUR="SUPERADMINISTRATEUR",
    GESTIONNAIRE="GESTIONNAIRE",
    TECHNICIEN="TECHNICIEN",
    SUPERVISEUR="SUPERVISEUR",
    DOCTEUR="DOCTEUR",
    MEDECIN="MEDECIN",
    AIDE_MEDECIN="AIDE_MEDECIN",
    DAF="DAF",
    AUTRE="AUTRE",
}



export enum Fonction {
    DOCTER = "Docter",
    MEDECIN = "Médecin",
    MAGASINIER = "Magasinier",
    SUPERVISEUR = "Superviseur",
    SIMPLE_USER = "Utilisateur Simple",
    DAF = "DAF"
}






@Injectable({
    providedIn: 'root'
})
export class CurrentUserService {
    private currentUserSubject: BehaviorSubject<any | null>;
    public currentUser: Observable<any | null>;
    baseUrl=environment.baseUrl
    tabPermission:any[]=[]
    constructor(private http:HttpClient) {
        // On récupère l'utilisateur actuel (par exemple depuis le localStorage ou autre)
        const currentUser = JSON.parse(sessionStorage.getItem('currentUser') || 'null');
        this.currentUserSubject = new BehaviorSubject<any | null>(currentUser);
        this.currentUser = this.currentUserSubject.asObservable();
        // Note : on ne peuple PAS tabPermission depuis currentUser.roles ici.
        // Les comptes normaux (proprietaire/admin d'une structure inclus) ont un
        // tableau `roles` global VIDE ([]) - toutes leurs permissions reelles
        // viennent du role attribue par structure (UserStructureAppartenance),
        // jamais des roles globaux du JWT. Voir setPermissionsFromRole(), appelee
        // par app.menu.component.ts une fois l'appartenance a la structure
        // courante recuperee. Utiliser currentUser.roles ici (comme avant)
        // laissait tabPermission perpetuellement vide pour tout le monde, donc
        // hasPermissions() renvoyait toujours false : boutons "Ajouter" et
        // tableaux entiers invisibles partout dans l'app (structures,
        // departements, equipements, utilisateurs...).
    }

    // Accéder à l'utilisateur actuel
    public get currentUserValue(): any | null {
        return this.currentUserSubject.value;
    }


public currentUserRoles!: any;

    /**
     * Recharge tabPermission depuis le role attribue a l'utilisateur sur la
     * structure courante (voir UserStructureAppartenanceDTO.role.permissions
     * cote backend). A appeler des que ce role est connu (typiquement dans
     * app.menu.component.ts, juste apres l'appel a
     * structures-appartenance/by-structure-id/{id}).
     */
    setPermissionsFromRole(role: any): void {
        this.tabPermission = [];
        (role?.permissions || []).forEach((permission: any) => {
            if (permission?.name) {
                this.tabPermission.push(permission.name);
            }
        });
    }

  hasPermissions(permission:string){

       return this.tabPermission.includes(permission)? true:false
  }

  hasAnyRole(roles: RoleUtilisateur[]): boolean {
    return roles.some(r => this.currentUserRoles.includes(r));
  }

    // Mettre à jour l'utilisateur
    setCurrentUser(user: any): void {
        sessionStorage.setItem('currentUser', JSON.stringify(user));
        if (user?.token) {
            sessionStorage.setItem('token', user.token);
        }
        this.currentUserSubject.next(user);
    }

    // Supprimer l'utilisateur (par exemple lors de la déconnexion)
    logout(): void {
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }

    getUsers(): Observable<User[]> {
        return this.http.get<User[]>(`${this.baseUrl}/users/all`);
    }
    token=sessionStorage.getItem("token")
    getPersonnels(idStructure?: string): Observable<User[]> {
        let url = `${this.baseUrl}/users/personnel`;
        if (idStructure) {
            url += `/${idStructure}`;
        }
        return this.http.get<User[]>(url);
    }
    getTechnicians(idStructure?: string): Observable<User[]> {
        let url = `${this.baseUrl}/users/techniciens`;
        if (idStructure) {
            url += `/${idStructure}`;
        }
        return this.http.get<User[]>(url);
    }

    // Obtenir un utilisateur par son ID
    getUserById(id: string): Observable<User> {
        return this.http.get<User>(`${this.baseUrl}/users/${id}`);
    }

    // Créer un nouvel utilisateur
    addUser(data: User): Observable<User> {
        return this.http.post<User>(`${this.baseUrl}/users/create`, data);
    }


    // Mettre à jour un utilisateur
    // Le token etait ajoute en segment d'URL (/users/update/{id}/{token}), un
    // en-tete Authorization etant deja envoye par l'intercepteur HTTP : la
    // route backend n'attend qu'un seul segment (/users/update/{id}), donc ce
    // segment en trop faisait 404 sur CHAQUE modification, sans exception.
    updateUser(id: string, data: User): Observable<User> {
        return this.http.put<User>(`${this.baseUrl}/users/update/${id}`, data);
    }

    // Supprimer un utilisateur (meme bug de segment d'URL en trop que ci-dessus)
    deleteUser(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/users/delete/${id}`);
    }
}
